module.exports = __webpack_public_path__ + "img/gopay-only.4266f944.png";